import type { ConsentState, ConsentUiMode } from "./types";

export type ConsentUiVisibility = "hidden" | "prompt" | "preferences";

type ConsentUiDecision = {
  state: ConsentState;
  /** Persisted visitor-decision state, separate from effective delivery fences. */
  decisionState?: ConsentState;
  mode?: ConsentUiMode;
  gpc: boolean;
  dnt: boolean;
  isShopify: boolean;
  hasHostCmp: boolean;
  forceOpen?: boolean;
  showPreferencesButton?: boolean;
};

export function resolveConsentUiVisibility({
  state,
  decisionState,
  mode = "auto",
  gpc,
  dnt,
  isShopify,
  hasHostCmp,
  forceOpen = false,
  showPreferencesButton = true,
}: ConsentUiDecision): ConsentUiVisibility {
  if (mode === "host" || isShopify || gpc || dnt) return "hidden";
  if (mode === "auto" && hasHostCmp) return "hidden";
  // A delivery fence may deny collection before the visitor has answered.
  // This affects visibility only; the effective state and all gates stay denied.
  if (
    forceOpen ||
    state === "unknown" ||
    (state === "denied" && decisionState === "unknown")
  )
    return "prompt";
  return showPreferencesButton ? "preferences" : "hidden";
}

export function sanitizePrivacyUrl(
  value: unknown,
  baseUrl: string,
): string | undefined {
  if (typeof value !== "string" || !value.trim()) return undefined;
  try {
    const url = new URL(value, baseUrl);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.toString()
      : undefined;
  } catch {
    return undefined;
  }
}
